import React from 'react'
import Link from 'gatsby-link'
import { Box, Toolbar } from 'rebass'
import styled from 'styled-components'
import { filter } from 'lodash'
import HamburgerMenu from 'react-hamburger-menu'

// styles
const StyledLink = styled(Link)`
  font-size: ${props => (props.type === 'mobile' ? '1.5rem' : '0.875rem')};
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: inherit;
  padding: 0.25rem 1rem;
  &:disabled {
    opacity: 0.25;
  }
`
const StyledButton = styled.button`
  font-size: ${props => (props.type === 'mobile' ? '1.25rem' : '0.875rem')};
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: white;
  border: none;
  background: ${props => props.theme.colors.green};
  padding: 0.25rem 1rem;
  margin-top: 1.5rem;
  &:disabled {
    opacity: 0.25;
  }
`
const MobileToolbar = styled(Toolbar)`
  padding: 2rem 1rem;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  background: white;
  z-index: 50;
  transform: ${props => (props.open ? 'translateY(0%)' : 'translateY(-100%)')};
  opacity: ${props => (props.open ? '1' : '0')};
  transition: 0.25s;
`

class MobileNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.menuOff = this.menuOff.bind(this)
  }

  toggleMenu() {
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen,
    }))
  }

  menuOff() {
    this.setState({
      menuOpen: false,
    })
  }

  render() {
    const { menu, language, switchLang } = this.props
    const { menuOpen } = this.state

    return (
      <div style={{ marginBottom: '3rem' }}>
        <MobileToolbar
          px={4}
          bg="white"
          flexDirection="column"
          color="#4BC169"
          border={1}
          open={menuOpen}
        >
          {filter(menu.items, { object: 'page' }).map(item => (
            <StyledLink
              type="mobile"
              exact
              to={item.object_slug === 'index' ? '/' : `/${item.object_slug}`}
              activeStyle={{ textDecoration: 'underline' }}
              onClick={menuOpen}
            >
              {item.title}
            </StyledLink>
          ))}
          <StyledButton
            type="mobile"
            onClick={() => {
              switchLang()
              this.menuOff()
            }}
          >
            {language === 'english'
              ? 'Switch Language: Fr'
              : 'Switch Language: En'}
          </StyledButton>
        </MobileToolbar>
        <Box
          style={{
            position: 'absolute',
            top: '1rem',
            right: '2rem',
            zIndex: 60,
          }}
        >
          <HamburgerMenu
            isOpen={menuOpen}
            menuClicked={this.toggleMenu}
            width={18}
            height={15}
            strokeWidth={1}
            rotate={0}
            color="#4BC169"
            borderRadius={0}
            animationDuration={0.25}
          />
        </Box>
      </div>
    )
  }
}

export default MobileNav



// WEBPACK FOOTER //
// ./src/components/MobileNav.js